<template>
    <component
        :is="element"
        class="dashed-text"
    >
        <div class="dashed-text__left"><slot name="left" /></div>
        <div class="dashed-text__line" />
        <div class="dashed-text__right"><slot name="right" /></div>
    </component>
</template>

<script setup>
defineProps({
    element: {
        type: [String, Object],
        default: 'div'
    }
});
</script>

<style lang="less">
.dashed-text {
    .typography-label();

    position: relative;
    z-index: 10;

    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    align-items: center;
    gap: .38rem;
    width: 100%;
}

.dashed-text__line {
    position: relative;
    width: 100%;
    height: 1px;
    flex: 1 1 0;

    background-color: currentColor;
}

.dashed-text__right {
    white-space: nowrap;
}
</style>
